<template>
	<JBox>
		<!-- Data Type -->
		<JSelect v-model="dataType" :options="dataTypeOptions" @input="switchDataType($event)" />

		<!-- Form Input based on dataType -->
		<JBox class="s-mt-1">
			<JInputText v-if="dataType === 'string'" v-model="form" @input="handleInput" />
			<JInputNumber v-else-if="dataType === 'number'" v-model="form" @input="handleInput" />
			<JToggle v-if="dataType === 'boolean'" v-model="form" @input="handleInput" />
			<JDatePicker v-if="dataType === 'date'" v-model="form" @input="handleInput" />
			<CCodeEditor v-if="dataType === 'complex'" language="json" v-model="form" @input="handleInput" />
		</JBox>
	</JBox>
</template>

<script>
import isObject from "lodash.isobject"

export default {
	// Accepts stringified json
	props: ["value"],

	data() {
		return {
			dataType: null,
			form: null,

			dataTypeOptions: [
				{ name: "Number", value: "number" },
				{ name: "Text", value: "string" },
				{ name: "Boolean", value: "boolean" },
				{ name: "Date", value: "date" },
				{ name: "Complex", value: "complex" }
			]
		}
	},

	methods: {
		parseJsonValue(value) {
			if (value === null || value === undefined) return

			// do nothing if dataType was already defined
			if (this.dataType !== null) return

			// Helper fn to parse string and determine if it is an object (object or array)
			const isStringObject = str => {
				try {
					if (isObject(str)) return true
				} catch (e) {
					return false
				}
			}

			try {
				value = JSON.parse(value)
			} catch (e) {
				return
			}

			// ISO date string regex to check whether string is a date
			const ISO_8601 = new RegExp(/^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/, "i")

			if (typeof value === "number") {
				this.dataType = "number"
				this.form = value ?? 0
			} else if (typeof value === "boolean") {
				this.dataType = "boolean"
				this.form = value ?? false
			} else if (ISO_8601.test(value)) {
				this.dataType = "date"
				this.form = value ?? new Date().toISOString()
			} else if (isStringObject(value)) {
				this.dataType = "complex"
				this.form = JSON.stringify(value) // we have to stringify for the code editor
			} else if (value && typeof value === "string") {
				this.dataType = "string"
				this.form = value ?? ""
			} else {
				this.dataType = null
				this.form = null
			}

			this.handleInput()
		},

		switchDataType(dataType) {
			if (!dataType) {
				this.form = null
				this.handleInput()
				return
			}

			if (dataType === "number") this.form = 0
			if (dataType === "string") this.form = ""
			if (dataType === "boolean") this.form = false
			if (dataType === "date") this.form = new Date().toISOString()
			if (dataType === "complex") this.form = JSON.stringify({})

			this.handleInput()
		},

		handleInput() {
			this.$emit("input", this.form)
			this.$emit("dataType", this.dataType)
		}
	},

	watch: {
		value: {
			handler() {
				this.parseJsonValue(this.value)
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
